import { useQuery } from "react-query";
import { PaginatedFilter } from "../types/axios.types";
import {
  fetchEnterprise,
  fetchEnterpriseCenters,
  fetchEnterprises,
} from "../queries/enterprises.queries";

export const useEnterprises = (
  page?: number,
  size?: number,
  search?: string,
  filters?: PaginatedFilter,
  sortBy?: string[],
  isArchived?: boolean
) => {
  const query = useQuery(
    ["enterprises", page, size, search, filters, sortBy, isArchived],
    () => {
      try {
        return fetchEnterprises(
          page,
          size,
          search,
          filters,
          sortBy,
          isArchived
        );
      } catch (err) {
        return null;
      }
    },
    { keepPreviousData: true }
  );
  return query?.data;
};

export const useEnterprise = (id: string | number | null | undefined) => {
  return useQuery(["enterprises", id], () => {
    try {
      return fetchEnterprise(id);
    } catch (err) {
      return null;
    }
  });
};

export const useEnterpriseCenters = ({ id }: { id: number }) => {
  return (
    page?: number,
    size?: number,
    search?: string,
    filters?: PaginatedFilter,
    sortBy?: string[]
  ) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const query = useQuery(
      ["enterprise-centers", id, page, size, search, filters, sortBy],
      () => {
        try {
          return fetchEnterpriseCenters(
            id,
            page,
            size,
            search,
            filters,
            sortBy
          );
        } catch (err) {
          return null;
        }
      },
      { keepPreviousData: true }
    );
    return query?.data;
  };
};
